<app-header [logoImg]="logoImg" [loginButton]="loginButton" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_fullwhite.png" [stickyHeaderWhite]="true"></app-header>
<div class="main-content">
    <app-contact-us-form></app-contact-us-form>
</div>
<app-contact-card></app-contact-card>
<app-footer></app-footer>